// العربية — الإمارات العربية المتحدة
export default {
  translation: {
    app_name: 'Agora',
    tagline: 'حيث تبني الهوايات المجتمعات',
    nav_explore: 'استكشاف',
    nav_find_folks: 'البحث عن أشخاص',
    nav_sign_in: 'تسجيل الدخول',
    nav_join_free: 'انضم مجاناً',
    nav_sign_out: 'تسجيل الخروج',
    nav_my_profile: 'ملفي الشخصي',
    nav_notifications: 'الإشعارات',
    auth_register: 'إنشاء حساب',
    auth_login: 'تسجيل الدخول',
    auth_name: 'الاسم الكامل',
    auth_email: 'البريد الإلكتروني',
    auth_password: 'كلمة المرور',
    auth_age: 'عمرك',
    auth_city: 'المدينة',
    auth_building: 'المبنى / المجمع السكني',
    auth_country: 'الدولة',
    auth_currency: 'العملة',
    auth_locale: 'اللغة والمنطقة',
    auth_already_have_account: 'هل لديك حساب؟',
    auth_no_account: 'ليس لديك حساب؟',
    postcode_label: 'الرمز البريدي',
    postcode_placeholder: '',
    profile_edit: 'تعديل الملف الشخصي',
    profile_bio: 'نبذة تعريفية',
    profile_interests: 'الاهتمامات',
    profile_location: 'الموقع',
    profile_theme: 'مظهر التطبيق',
    profile_currency_settings: 'العملة والمنطقة',
    profile_save: 'حفظ التغييرات',
    profile_cancel: 'إلغاء',
    group_join: 'انضم للمجموعة',
    group_leave: 'مغادرة المجموعة',
    group_members: 'الأعضاء',
    group_chat: 'المحادثة',
    group_events: 'الفعاليات',
    group_shop: 'المتجر',
    group_campaigns: 'الحملات',
    group_about: 'حول',
    group_full: 'ممتلئة',
    group_open: 'مفتوحة',
    tip_send: 'إرسال إكرامية',
    tip_amount: 'المبلغ',
    tip_message: 'رسالة (اختياري)',
    wallet_coins: 'عملات',
    wallet_balance: 'الرصيد',
    tips_earned: 'مكتسب',
    event_register: 'التسجيل',
    event_unregister: 'إلغاء التسجيل',
    event_ticket_price: 'تذكرة',
    event_free: 'مجاني',
    event_capacity: 'السعة',
    event_registered: 'مسجل',
    no_results: 'لا توجد نتائج',
    loading: 'جارٍ التحميل…',
    error_generic: 'حدث خطأ ما. يرجى المحاولة مرة أخرى.',
  }
};
